import './VisuallyHidden.css';
export var visuallyHiddenCSS = '_1mi7src0-2-0-1';